import { render, staticRenderFns } from "./Prevention.vue?vue&type=template&id=53dd57e1&"
import script from "./Prevention.vue?vue&type=script&lang=js&"
export * from "./Prevention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports